import * as R from 'ramda';

import { STH_WENT_WRONG } from 'constants/constant-errors';

const formatError = err => R.path(['graphQLErrors', 0, 'extensions', 'body', 'message'], err) || STH_WENT_WRONG;

export default formatError;
